import axios from "@/plugins/axios";

// This optional follow-up must never turn a successful customer save into an error.
export async function hasAssignableCustomerCatalogs(customerId, canViewCatalogs) {
    if (!customerId || !canViewCatalogs) return false;
    try {
        const { data } = await axios.get("/api/catalogs/", {
            params: {
                assignment_customer: customerId,
                type: "sell",
                limit: 1,
                offset: 0,
            },
        });
        return Array.isArray(data.results) && data.results.length > 0;
    } catch (_) {
        // Assignment remains available manually from the customer record.
        return false;
    }
}
